<template>
  <DropdownMenuItem
    data-slot="dropdown-menu-item"
    :data-inset="inset ? '' : undefined"
    :data-variant="variant"
    v-bind="forwardedProps"
    :class="cn(dropdownMenuItemVariants(), props.class)"
  >
    <slot />
  </DropdownMenuItem>
</template>

<script setup lang="ts">
import { reactiveOmit } from "@vueuse/core";
import {
  DropdownMenuItem,
  type DropdownMenuItemProps,
  useForwardProps,
} from "reka-ui";
import type { HTMLAttributes } from "vue";
import { dropdownMenuItemVariants } from "./variants";
import { cn } from "@/lib/utils";

const props = withDefaults(
  defineProps<
    DropdownMenuItemProps & {
      class?: HTMLAttributes["class"];
      inset?: boolean;
      variant?: "default" | "danger";
    }
  >(),
  {
    class: undefined,
    variant: "default",
  },
);

const delegatedProps = reactiveOmit(props, "inset", "variant");

const forwardedProps = useForwardProps(delegatedProps);
</script>
